import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import format from 'date-fns/format';
import Pagination from '../../../components/Pagination/Pagination';
import Loader from '../../../components/Loader/Loader';
import Snackbar from '../../../components/Snackbar/Snackbar';
import Tabs from '../../../components/Tab/Tab';
import Table from '../../../components/Table/Table';
import Button from '../../../components/Button/CustomButton';
import { DownloadIcon } from '../../../components/Icons/Icon';
import API from '../../../common/API';

const TapValue = {
    product: 0,
    seminar: 1,
    liveStream: 2,
    orderProduct: 3,
};
const BASE_URL = process.env.REACT_APP_API_URL_BASE;

const VisitHistoryManagement = ({
    seminarList, isLoading,
    listCompanyEvent, fetchListCompanyEvent,
    getCSVSeminarViewer, successCSVSeminar,
    getCSVExhibitionViewer, exhibitionList,
    successCSVExhibition, clearData,
    exhibitionErrors, seminarErrors, getAllErrors,
    token, eventInfo, livestreamList, livestreamErrors,
    successCSVLivestream, getCSVLivestreamViewer, grandBoothList,
    grandBoothErrors, successCSVGrandBooth, getCSVGrandBoothViewer,
}) => {
    const intl = useIntl();
    const { shortName } = useParams();
    const [currentTab, setCurrentTab] = useState(0);
    const [nameCompany, setNameCompany] = useState();
    const [dataTable, setDataTable] = useState([]);
    const [errorDialog, setErrorDialog] = useState({ isOpen: false, message: '' });

    useEffect(() => {
        fetchListCompanyEvent({ event_name: shortName, isPageFooter: true });
        return () => {
            clearData();
        };
    }, [shortName]);

    useEffect(() => {
        if (exhibitionErrors.code === 'BAD_REQUEST') {
            setErrorDialog({ isOpen: true, message: exhibitionErrors.message.message });
        }
        if (seminarErrors.code === 'BAD_REQUEST') {
            setErrorDialog({ isOpen: true, message: seminarErrors.message.message });
        }
        if (getAllErrors.code === 'BAD_REQUEST') {
            setErrorDialog({ isOpen: true, message: getAllErrors.message.message });
        }
        if (livestreamErrors.code === 'BAD_REQUEST') {
            setErrorDialog({ isOpen: true, message: livestreamErrors.message.message });
        }
        if (grandBoothErrors.code === 'BAD_REQUEST') {
            setErrorDialog({ isOpen: true, message: grandBoothErrors.message.message });
        }
    }, [exhibitionErrors, seminarErrors, getAllErrors, livestreamErrors, grandBoothErrors]);

    useEffect(() => {
        if (listCompanyEvent.results && listCompanyEvent.results.length > 0) {
            setDataTable(listCompanyEvent.results);
        } else {
            setDataTable([]);
        }
    }, [listCompanyEvent]);

    useEffect(() => {
        if (seminarList && successCSVSeminar) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', seminarList]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `セミナー受講閲覧履歴_${`${nameCompany}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [seminarList, successCSVSeminar]);

    useEffect(() => {
        if (exhibitionList && successCSVExhibition) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', exhibitionList]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `展示会閲覧履歴_${`${nameCompany}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [exhibitionList, successCSVExhibition]);

    useEffect(() => {
        if (livestreamList && successCSVLivestream) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', livestreamList]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `ライブ配信申込み履歴_${`${nameCompany}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [livestreamList, successCSVLivestream]);

    useEffect(() => {
        if (grandBoothList && successCSVGrandBooth) {
            const downloadLink = document.createElement('a');
            const blob = new Blob(['\ufeff', grandBoothList]);
            const url = URL.createObjectURL(blob);
            downloadLink.href = url;
            const dateDownload = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
            downloadLink.download = `商品注文履歴_${`${nameCompany}_${dateDownload}`}.csv`;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }, [grandBoothList, successCSVGrandBooth]);

    const handleChangeTab = (val) => {
        setCurrentTab(val);
        fetchListCompanyEvent({ event_name: shortName, isPageFooter: true });
    };

    const handleGetCSVSeminar = (companyId) => {
        getCSVSeminarViewer({ event_name: shortName, company_id: companyId });
    };
    const handleGetCSVProduct = (companyId) => {
        getCSVExhibitionViewer({ event_name: shortName, company_id: companyId });
    };
    const handleGetCSVLiveStream = (companyId) => {
        getCSVLivestreamViewer({ event_name: shortName, company_id: companyId });
    };
    const handleGetCSVOrderProduct = (companyId) => {
        getCSVGrandBoothViewer({ event_name: shortName, company_id: companyId });
    };

    const handleGetAllCSV = () => {
        // getAllCSV({ currentTab, event_name: shortName });

        let endpointRequest = '';
        if (currentTab === TapValue.seminar) {
            endpointRequest = `${BASE_URL}/api/v1/event/${shortName}/company/download-csv-seminar/?token=${token}`;
        } else if (currentTab === TapValue.liveStream) {
            endpointRequest = `${BASE_URL}/api/v1/event/${shortName}/company/download_csv_live_stream/?token=${token}`;
        } else if (currentTab === TapValue.orderProduct) {
            endpointRequest = `${BASE_URL}/api/v1/event/${shortName}/company/download_csv_grand_booth/?token=${token}`;
        } else {
            endpointRequest = `${BASE_URL}/api/v1/event/${shortName}/company/download-csv-product/?token=${token}`;
        }

        API.get({
            endpoint: endpointRequest,
        })
        .then(() => {
            const downloadLink = document.createElement('a');
            downloadLink.href = endpointRequest;

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        })
        .catch((error) => {
            if (error?.errors?.code === 'BAD_REQUEST') {
                setErrorDialog({ isOpen: true, message: error?.errors?.message.message });
            }
        });
    };

    const titleHeader = () => {
        let headerData = [
            intl.formatMessage({ id: 'visitHistoryManagement.exhibitionVisit' }),
            intl.formatMessage({ id: 'visitHistoryManagement.seminarVisit' }),
            intl.formatMessage({ id: 'visitHistoryManagement.liveStreamVisit' }),
        ];
        if (eventInfo.has_shopping_cart && eventInfo.grand_zone) {
            headerData = [
                ...headerData,
                intl.formatMessage({ id: 'visitHistoryManagement.orderProductGrandBooth' }),
            ];
        }
        return headerData;
    };

    return (
        <>
            <Tabs
                headers={titleHeader()}
                onChangeTab={handleChangeTab}
            />
            <Button
                color="info"
                gradient
                size="md"
                round
                style={{
                    margin: '10px auto',
                    fontSize: 20,
                    display: 'flex',
                    fontWeight: 'bold',
                }}
                onClick={handleGetAllCSV}
            >
                すべてダウンロード
            </Button>
            {currentTab === TapValue.product && (
                <Table
                    tableHead={[
                        intl.formatMessage({ id: 'nameCompany' }),
                        intl.formatMessage({ id: 'csvProduct' }),
                    ]}
                    tableHeadWidth={['40%', '60%']}
                    tableData={dataTable.map((item) => ([
                        item.full_name,
                        <Button
                            color="info"
                            gradient
                            size="md"
                            round
                            onClick={() => {
                                setNameCompany(item.full_name);
                                handleGetCSVProduct(item.id);
                            }}
                            download
                        >
                            <DownloadIcon />
                            &#160;
                            CSVダウンロード
                        </Button>,

                    ]))}
                    tableFooter={(
                        <Box display="flex" justifyContent="center">
                            <Pagination
                                page={listCompanyEvent.page}
                                total={listCompanyEvent.total_page}
                                onChange={(page) => fetchListCompanyEvent({ event_name: shortName, page, isPageFooter: true })}
                            />
                        </Box>
                    )}
                    pointerLess
                />
            )}
            {currentTab === TapValue.seminar && (
                <Table
                    tableHead={[
                        intl.formatMessage({ id: 'nameCompany' }),
                        intl.formatMessage({ id: 'csvSeminar' }),
                    ]}
                    tableHeadWidth={['40%', '60%']}
                    tableData={dataTable.map((item) => ([
                        item.full_name,
                        <Button
                            color="info"
                            gradient
                            size="md"
                            round
                            onClick={() => {
                                setNameCompany(item.full_name);
                                handleGetCSVSeminar(item.id);
                            }}
                        >
                            <DownloadIcon />
                            &#160;
                            CSVダウンロード
                        </Button>,
                    ]))}
                    tableFooter={(
                        <Box display="flex" justifyContent="center">
                            <Pagination
                                page={listCompanyEvent.page}
                                total={listCompanyEvent.total_page}
                                onChange={(page) => fetchListCompanyEvent({ event_name: shortName, page, isPageFooter: true })}
                            />
                        </Box>
                    )}
                    pointerLess
                />
            )}
            {currentTab === TapValue.liveStream && (
                <Table
                    tableHead={[
                        intl.formatMessage({ id: 'nameCompany' }),
                        intl.formatMessage({ id: 'csvLiveStream' }),
                    ]}
                    tableHeadWidth={['40%', '60%']}
                    tableData={dataTable.map((item) => ([
                        item.full_name,
                        <Button
                            color="info"
                            gradient
                            size="md"
                            round
                            onClick={() => {
                                setNameCompany(item.full_name);
                                handleGetCSVLiveStream(item.id);
                            }}
                        >
                            <DownloadIcon />
                            &#160;
                            CSVダウンロード
                        </Button>,
                    ]))}
                    tableFooter={(
                        <Box display="flex" justifyContent="center">
                            <Pagination
                                page={listCompanyEvent.page}
                                total={listCompanyEvent.total_page}
                                onChange={(page) => fetchListCompanyEvent({ event_name: shortName, page, isPageFooter: true })}
                            />
                        </Box>
                    )}
                    pointerLess
                />
            )}
            {currentTab === TapValue.orderProduct && (
                <Table
                    tableHead={[
                        intl.formatMessage({ id: 'nameCompany' }),
                        intl.formatMessage({ id: 'csvOrderProduct' }),
                    ]}
                    tableHeadWidth={['40%', '60%']}
                    tableData={dataTable.map((item) => ([
                        item.full_name,
                        <Button
                            color="info"
                            gradient
                            size="md"
                            round
                            onClick={() => {
                                setNameCompany(item.full_name);
                                handleGetCSVOrderProduct(item.id);
                            }}
                        >
                            <DownloadIcon />
                            &#160;
                            CSVダウンロード
                        </Button>,
                    ]))}
                    tableFooter={(
                        <Box display="flex" justifyContent="center">
                            <Pagination
                                page={listCompanyEvent.page}
                                total={listCompanyEvent.total_page}
                                onChange={(page) => fetchListCompanyEvent({ event_name: shortName, page, isPageFooter: true })}
                            />
                        </Box>
                    )}
                    pointerLess
                />
            )}
            <Snackbar
                open={errorDialog.isOpen}
                onClose={() => setErrorDialog((state) => ({ ...state, isOpen: false }))}
                message={errorDialog.message}
            />
            <Loader isLoading={isLoading} />
        </>
    );
};

VisitHistoryManagement.defaultProps = {
    seminarList: '',
    exhibitionList: '',
    listCompanyEvent: {},
    exhibitionErrors: {},
    seminarErrors: {},
    getAllErrors: {},
    successCSVSeminar: false,
    successCSVExhibition: false,
    token: '',
    eventInfo: {},
    livestreamList: '',
    livestreamErrors: {},
    successCSVLivestream: false,
    getCSVLivestreamViewer: () => {},
    grandBoothList: '',
    grandBoothErrors: {},
    successCSVGrandBooth: false,
    getCSVGrandBoothViewer: () => {},
};

VisitHistoryManagement.propTypes = {
    fetchListCompanyEvent: PropTypes.func.isRequired,
    successCSVSeminar: PropTypes.bool,
    successCSVExhibition: PropTypes.bool,
    listCompanyEvent: PropTypes.objectOf(PropTypes.any),
    exhibitionErrors: PropTypes.objectOf(PropTypes.any),
    seminarErrors: PropTypes.objectOf(PropTypes.any),
    getAllErrors: PropTypes.objectOf(PropTypes.any),
    exhibitionList: PropTypes.string,
    getCSVSeminarViewer: PropTypes.func.isRequired,
    getCSVExhibitionViewer: PropTypes.func.isRequired,
    clearData: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    seminarList: PropTypes.string,
    token: PropTypes.string,
    eventInfo: PropTypes.objectOf(PropTypes.any),
    livestreamList: PropTypes.string,
    livestreamErrors: PropTypes.oneOfType(PropTypes.any),
    successCSVLivestream: PropTypes.bool,
    getCSVLivestreamViewer: PropTypes.func,
    grandBoothList: PropTypes.string,
    grandBoothErrors: PropTypes.oneOfType(PropTypes.any),
    successCSVGrandBooth: PropTypes.bool,
    getCSVGrandBoothViewer: PropTypes.func,
};

export default VisitHistoryManagement;
